import React, { ComponentType } from 'react';
import { Route } from 'react-router-dom';
import NoAccess from 'ui/error-pages/no-acces';

export interface IProtectedRoute {
  condition: boolean;
  component: ComponentType;
  // All other props
  [x: string]: any;
}

const ProtectedRoute = ({
  condition,
  component: Component,
  ...props
}: IProtectedRoute) => {
  return (
    <Route
      {...props}
      // @ts-ignore
      render={(props) => (condition ? <Component {...props} /> : <NoAccess />)}
    />
  );
};

export default ProtectedRoute;
